import { buildSkillStep } from "@/core/skillForms/builder";
import { FileTypes } from "@/core/skills/types";

export const createReplySkillStep4 = buildSkillStep({
  title: "Provas",
  description: "Anexe os documentos que serão utilizados como provas para fornecer o contexto do seu caso à IA:",
  fields: [
    {
      name: "evidence_documents",
      type: "file",
      ui: {
        label: "Anexar provas",
        description:
          "Anexe os arquivos referentes às provas, que serão utilizados para aprimorar a argumentação do caso. \n**Recomendamos organizar cada prova em arquivos separados, em vez de consolidá-las em um único documento.**",
        enableMarkdownInDescription: true,
        options: {
          multiple: true,
          accept: [FileTypes.PNG, FileTypes.JPEG, FileTypes.TIFF, FileTypes.PDF],
        },
      },
    },
  ],
  submitButtonText: "Escrever peça",
});
